<template>
  <div id="list-visit">

    <v-layout
      row
      wrap>
      <v-flex
        xs6
        sm4
        md3
      >
        <v-text-field
          v-model="search"
          class="pl-2 pr-2"
          prepend-icon="search"
          placeholder="Search all by Company/Customer/Activity/Visit By (Username)"
          clearable
          single-line
          hide-details/>
      </v-flex>
      <v-flex
        xs6
        sm4
        md3
      >
        <v-select
          v-model="searchBy.status"
          :items="visitStatus"
          class="pl-2 pr-2"
          menu-props="auto"
          input-value="-ALL-"
          placeholder="Select..."
        >
          <template v-slot:label>
            Status <v-icon style="vertical-align: middle">search</v-icon>
          </template>
        </v-select>
      </v-flex>
      <v-flex
        xs6
        sm4
        md3
      >
        <v-select
          v-model="searchBy.shodanYN"
          :items="['','Yes','No']"
          class="pl-2 pr-2"
          menu-props="auto"
          input-value="-ALL-"
          placeholder="Select..."
        >
          <template v-slot:label>
            Shodan Y/N <v-icon style="vertical-align: middle">search</v-icon>
          </template>
        </v-select>
      </v-flex>
      <v-flex
        xs6
        sm6
        md3
      >
        <v-select
          v-model="searchBy.createdBy"
          :items="userLogins"
          :item-text="usernameItemText"
          item-value="username"
          menu-props="auto"
          input-value="-ALL-"
          placeholder="Select..."
        >
          <template v-slot:label>
            Update By <v-icon style="vertical-align: middle">search</v-icon>
          </template>
        </v-select>
      </v-flex>
      <v-flex
        xs6
        sm4
        md3
      >
        <v-menu
          v-model="menuDatePicker"
          :nudge-right="40"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="computedSearchByVisitDateFrom"
              class="pl-2 pr-2"
              required
              prepend-icon="event"
              readonly
              v-on="on"
            >
              <template v-slot:label>
                Visit Date From<v-icon style="vertical-align: middle">search</v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="searchBy.visitDateFrom"
            no-title
            @input="menuDatePicker = false"/>
        </v-menu>
      </v-flex>
      <v-flex
        xs6
        sm4
        md3
      >
        <v-menu
          v-model="menuDatePicker2"
          :nudge-right="40"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="computedSearchByVisitDateTo"
              class="pl-2 pr-2"
              required
              prepend-icon="event"
              readonly
              v-on="on"
            >
              <template v-slot:label>
                Visit Date To<v-icon style="vertical-align: middle">search</v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="searchBy.visitDateTo"
            no-title
            @input="menuDatePicker2 = false"/>
        </v-menu>
      </v-flex>

    </v-layout>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="720px">
      <template v-slot:activator="{ on }">
        <v-btn
          color="general"
          class="mb-2 ml-1 mr-1"
          dark
          v-on="on">New
        </v-btn>
      </template>
      <v-form
        id="form1-vue"
        ref="form1"
        v-model="valid1"
        :lazy-validation="lazyValidation1"
      >
        <v-card>
          <v-chip
            label
            color="general"
            text-color="white">
            <v-icon left>label</v-icon>
            {{ visitType }} Visit
          </v-chip>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex
                  xs6
                  sm6
                  md4
                >
                  <v-select
                    v-model="editedItem.status"
                    :rules="[rules.required]"
                    :items="visitStatus"
                    menu-props="auto"
                    label="Status"
                    required
                    input-value="DRAFT"
                    placeholder="Select..."
                  />
                </v-flex>
                <v-flex
                  xs6
                  sm6
                  md4
                >
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :rules="[rules.required]"
                        :value="computedDateFormatted"
                        label="Visit Date *"
                        hint="DD/MM/YYYY"
                        required
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="editedItem.visitDate"
                      no-title
                      @input="menu = false"/>
                  </v-menu>
                </v-flex>
                <v-flex
                  v-if="allowSelectUser"
                  xs12
                  sm6
                  md4>
                  <v-select
                    :items="userLogins"
                    v-model="editedItem.username"
                    :rules="[rules.required]"
                    :item-text="usernameItemText"
                    menu-props="auto"
                    item-value="username"
                    label="Visit By"
                    placeholder="Select..."
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4>
                  <v-autocomplete
                    v-model="editedItem.customer.company.id"
                    :items="companies"
                    :rules="[rules.required]"
                    :search-input.sync="searchCompany"
                    hide-no-data
                    placeholder="type 3 words to search..."
                    label="Company *"
                    item-text="name"
                    item-value="id"
                    required
                    @input="onSelectCompany"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <!--  v-show="showCustomerSelect" we remove it -->
                  <v-select
                    :items="customers"
                    v-model="editedItem.customerSelect"
                    :rules="[rules.required]"
                    menu-props="auto"
                    item-text="name"
                    item-value="id"
                    required
                    label="Customer *"
                    return-object
                    placeholder="Select Company First"
                    @input="onSelectCustomerGetShodansOrProjects"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm4
                  md4
                >
                  <!--  v-show="showProjectSelect" we remove it -->
                  <v-select
                    v-if="visitType === 'SALES'"
                    v-show="showShodanSelect"
                    v-model="editedItem.shodan"
                    :items="shodans"
                    menu-props="auto"
                    item-text="name"
                    item-value="id"
                    label="Shodan"
                    return-object
                    placeholder="Select..."
                  />
                  <v-autocomplete
                      v-else
                      v-model="editedItem.project"
                      :items="projects"
                      :rules="[rules.required]"
                      :search-input.sync="searchProjectRef"
                      hide-no-data
                      placeholder="type 4 words to search..."
                      label="Project *"
                      item-text="refNo"
                      item-value="id"
                      required
                      return-object
                      @input="onSelectProjects"
                  >
                    <!-- Customize how items appear in the dropdown list -->
                    <template v-slot:item="data">
                      <template>
                        {{ data.item.refNo }} <small>({{ data.item.desc }})</small>
                      </template>
                    </template>
                    <!-- Customize how the selected item appears in the input -->
                    <template v-slot:selection="data">
                      <template>
                          {{ data.item.refNo }} <small>({{ data.item.desc }})</small>
                      </template>
                    </template>
                  </v-autocomplete>
<!--                  <v-select-->
<!--                    v-else-->
<!--                    v-model="editedItem.project"-->
<!--                    :items="projects"-->
<!--                    :item-text="(item) => {return item.refNo + ' (' + item.name + ') ' + (item.desc || '')}"-->
<!--                    menu-props="auto"-->
<!--                    item-value="id"-->
<!--                    label="Project"-->
<!--                    return-object-->
<!--                    placeholder="Select..."-->
<!--                  />-->
                </v-flex>
                <v-flex
                  xs6
                  sm3
                  md3
                >
                  <v-text-field
                    v-model="editedItem.timeStart"
                    :rules="[rules.number,rules.time,rules.required]"
                    label="Time Start *"
                    mask="time"
                    prepend-icon="mdi-timetable"
                    required
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs6
                  sm3
                  md3
                >
                  <v-text-field
                    v-model="editedItem.timeEnd"
                    :rules="[rules.number,rules.time,rules.required]"
                    label="Time End *"
                    mask="time"
                    prepend-icon="mdi-timetable"
                    required
                    class="blue-input"/>
                </v-flex>
                <v-flex
                  xs6
                  sm6
                  md6
                >
                  <v-text-field
                    v-show="showProjectSelect"
                    :value="projectAddInfo"
                    disabled
                    label="Project Add. Info"
                    prepend-icon="mdi-information-outline"
                    class="blue-input"/>
                </v-flex>
                <v-flex
                  xs12
                  sm8
                  md8
                >
                  <v-textarea
                    v-model="editedItem.activity"
                    :rules="[rules.required]"
                    label="Activiy Detail *"
                    counter
                    required
                    clearable
                    class="blue-input"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm4
                  md4
                >
                  <v-text-field
                    v-model="editedItem.attachUrl"
                    label="Attachment Url"
                    class="blue-input"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="red darken-1"
              flat
              @click="close">Cancel
            </v-btn>
            <v-btn
              :disabled="!valid1"
              flat
              color="green darken-1"
              @click="saveVisit"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-btn
      color="general"
      class="mb-2 ml-1 mr-1"
      dark
      @click="$refs.downloadExcel.generate()"
    >
      <download-excel
        ref="downloadExcel"
        :fetch="fetchData"
        :fields="excelFields"
        :before-generate="showProgressBar"
        :before-finish="hideProgressBar"
        :name="exportFileName"
        class="btn btn-default"
        worksheet="worksheet">
        <v-icon>mdi-file-excel</v-icon>&nbsp;
      </download-excel>Export All
    </v-btn>
    <v-btn
      :disabled="selectFileDisabled"
      class="mb-2 ml-1 mr-1"
      dark
      color="general"
      @click="$refs.inputUpload.click()">
      Select&nbsp;<v-icon>mdi-file-excel</v-icon>
    </v-btn>
    <input
      v-show="false"
      ref="inputUpload"
      type="file"
      @change="loadFile"
    >
    <v-chip
      v-show="showFilename"
      class="ma-1"
      color="general"
      label
      outline
    >
      <v-icon left>mdi-file-check</v-icon>
      {{ file.name }}
    </v-chip>
    <v-btn
      :loading="uploadFileLoading"
      :disabled="uploadFileDisabled"
      :dark="!uploadFileDisabled"
      color="general"
      class="mb-2 ml-1 mr-1"
      @click="uploadFile">Upload
      <v-icon>mdi-upload</v-icon>
    </v-btn>
    <v-progress-linear
      v-show="loadingBar"
      :indeterminate="true"/>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="DataList"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsAmount"
      :total-items="totalRows"
      :disable-initial-sort="disableInitSort"
      dense
      loading-text="Loading... Please wait"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="justify-center ">
          <!--          <div v-show="showEditDelete(props.item)">-->
          <v-icon
            medium
            class="mr-2"
            @click.stop="editItem(props.item)">edit
          </v-icon>
          <v-icon
            medium
            @click.stop="dialogDeleteShow(props.item)">delete
          </v-icon>
          <!--          </div>-->
        </td>
        <td>{{ props.item.visitDate }}</td>
        <td v-if="hasAttachUrl(props.item)">
          <a
              :href="props.item.attachUrl"
              target="_blank">
            {{ props.item.status }}</a></td>
        <td v-else>{{ props.item.status }}</td>
        <td>{{ props.item.customer.company.name }}</td>
        <td>{{ props.item.customer.name }}</td>
        <td>{{ props.item.activity }}</td>
        <td class="">{{ toTimeFormat(props.item.timeStart) }}</td>
        <td class="">{{ toTimeFormat(props.item.timeEnd) }}</td>
        <td>{{ showShodanOrProject(props.item) }}</td>
        <td>{{ userLoginMap[props.item.username] }}</td>
        <td>{{ userLoginMap[props.item.createdBy] }}</td>
        <td>{{ userLoginMap[props.item.lastUpdateBy] }}</td>
        <td>{{ toStringDate(props.item.lastUpdateDate) }}</td>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogDelete"
      max-width="400px">
      <v-card>
        <v-card-title class="headline">System Message Confirmation</v-card-title>
        <v-card-text>
          Are you sure want to remove this record? <br>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="red darken-1"
            text
            flat
            @click="dialogDelete = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            flat
            @click="deleteItem(deleteItemRecord)"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog
        v-model="dialogUploadFinish"
        scrollable
        persistent
        max-width="480px">
        <v-card>
          <v-card-title class="headline">Import Excel Information</v-card-title>
          <v-card-text>
            <div
              class="body-1"
              style="white-space: pre;">{{ uploadResponse.errMessage }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="green darken-1"
              text
              flat
              @click="dialogUploadFinish = false"
            >
              OK
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-icon
        size="16"
        @click="snack = false"
      >
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-layout></div>
</template>

<script>
  import displayFormatterMixins from './../../../mixins/displayFormatterMixins'
  import _ from 'lodash'
  import { mapState } from 'vuex'

  export default {
    name: 'ListVisit',
    mixins: [displayFormatterMixins],
    props: {
      visitType: String
    },
    data: () => ({
      userLoginMap: Map,
      menu: false,
      snack: false,
      snackText: '',
      snackColor: '',
      loadingBar: false,
      valid1: false,
      lazyValidation1: false,
      showCustomerSelect: false,
      showShodanSelect: false,
      showProjectSelect: false,
      menuDatePicker: false,
      menuDatePicker2: false,
      typeVisit: ['PROJECT', 'SALES'],
      visitStatus: ['DRAFT','CONFIRMED','FOLLOW_UP','INTERNAL','TRIAL'],
      editedIndex: -1,
      editedItem: {
        id: null,
        activity: '',
        type: '',
        status: 'DRAFT',
        visitDate: '',
        timeStart: '',
        timeEnd: '',
        username: localStorage.getItem('username'),
        customer: {
          id: null,
          name: '',
          company: {
            id: null,
            name: ''
          }
        },
        shodan: {
          id: null,
          name: ''
        },
        project: {
          id: null,
          refNo: ''
        },
        attachUrl: ''
      },
      defaultItem: {
        id: null,
        activity: '',
        type: '',
        status: 'DRAFT',
        visitDate: '',
        timeStart: '',
        timeEnd: '',
        username: localStorage.getItem('username'),
        customer: {
          id: null,
          name: '',
          company: {
            id: null,
            name: ''
          }
        },
        shodan: {
          id: null,
          name: ''
        },
        project: {
          id: null,
          refNo: '',
          name: ''
        },
        attachUrl: ''
      },
      file: {},
      selectFileDisabled: false,
      uploadFileDisabled: true,
      uploadFileLoading: false,
      showFilename: false,
      uploadResponse: {},
      rules: {
        required: value => !!value || 'Required',
        number: value => !isNaN(value) || 'Must be numeric',
        time: value => {
          // ignore `:` masked already
          const pattern = /^([0-1]?[0-9]|2[0-4])([0-5][0-9])(:[0-5][0-9])?$/
          return !value || pattern.test(value) || 'Invalid 24h time format'
        },
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // projectAddInfo: '',
      companies: [],
      customers: [],
      projects: [],
      userLogins: [],
      shodans: [],
      pagination: {},
      DataList: [],
      totalRows: 0,
      rowsAmount: [5, 20, 50, 100],
      disableInitSort: true,
      dialog: false,
      dialogDelete: false,
      dialogUploadFinish: false,
      deleteItemRecord: {},
      loading: true,
      search: '',
      searchBy: {
        status: '',
        shodanYN: '',
        visitDateFrom: '',
        visitDateTo: '',
        lastUpdateBy: '',
        createdBy: '',
      },
      queryList: '',
      headers: [
        { text: '--Actions--', value: 'actions', sortable: false },
        { text: 'Visit Date', value: 'visitDate' },
        { text: 'Status', value: 'status' },
        { text: 'Company', value: 'customer.company.name' },
        { text: 'Customer', value: 'customer.name' },
        { text: 'Activity', value: 'activity' },
        { text: 'Time Start', value: 'timeStart' },
        { text: 'Time End', value: 'timeEnd' },
        { text: 'Shodan/Project', value: 'project.refNo', sortable: false },
        { text: 'Visit By', value: 'username' },
        { text: 'Created By', value: 'createdBy' },
        { text: 'Update By', value: 'lastUpdateBy' },
        { text: 'Update Date Time', value: 'lastUpdateDate' }
      ],
      excelFields: {
        'Visit Date': {
          callback: (value) => {
            return new Date(value.visitDate).toLocaleDateString('en-GB')
          }
        },
        'Status': 'status',
        'Company': 'customer.company.name',
        'Add. Info': 'project.addInfo',
        'Customer': 'customer.name',
        'Activity': 'activity',
        'Time Start': {
          callback: (value) => {
            let str = value.timeStart
            if (str && str.length === 4) {
              return str.slice(0, 2) + ':' + str.slice(2, 4)
            }
            return str
          }
        },
        'Time End': {
          callback: (value) => {
            let str = value.timeEnd
            if (str && str.length === 4) {
              return str.slice(0, 2) + ':' + str.slice(2, 4)
            }
            return str
          }
        },
        'Shodan/Project': {
          callback: (obj) => {
            if (obj.type === 'PROJECT') {
              if (!_.isEmpty(obj.project) && !_.isEmpty(obj.project.refNo)) {
                return obj.project.refNo
              }
            } else {
              if (!_.isEmpty(obj.shodan) && !_.isEmpty(obj.shodan.name)) {
                return obj.shodan.name
              }
            }
            return 'N'
          }
        },
        'Shodan/Project Desc': {
          callback: (obj) => {
            if (obj.type === 'PROJECT') {
              if (!_.isEmpty(obj.project) && !_.isEmpty(obj.project.refNo)) {
                return obj.project.desc
              }
            } else {
              if (!_.isEmpty(obj.shodan) && !_.isEmpty(obj.shodan.name)) {
                return obj.shodan.desc
              }
            }
            return 'N/A'
          }
        },
        'Visit By': 'username',
        'Attachment Url': 'attachUrl',
        'Created By': 'createdBy',
        'Update By': 'lastUpdateBy',
        'Update Date Time': {
          callback: (value) => {
            return new Date(value.lastUpdateDate).toLocaleDateString('en-GB')
          }
        }
      },
      searchCompany: '',
      searchProjectRef: ''

    }),
    computed: {
      ...mapState(['user']),
      computedDateFormatted () {
        return this.formatDate(this.editedItem.visitDate)
      },
      computedSearchByVisitDateFrom () {
        return this.formatDate(this.searchBy.visitDateFrom)
      },
      computedSearchByVisitDateTo () {
        return this.formatDate(this.searchBy.visitDateTo)
      },
      exportFileName () {
        return this.visitType === 'PROJECT' ? 'Visit-Project.xls' : 'Visit-Sales.xls'
      },
      allowSelectUser () {
        return this.$store.getters['hasPermission']('MA_MASTER_DATA')
      },
      projectAddInfo () {
        return this.editedItem.project ? this.editedItem.project.addInfo : ''
      }
    },
    watch: {
      pagination: {
        async handler () {
          this.getVisit()
        }
      },
      search () {
        this.debouncedGetData()
      },
      searchBy: {
        async handler () {
          this.getVisit()
        },
        deep: true
      },
      searchCompany () {
        if (this.searchCompany && this.searchCompany.length >= 3) {
          this.debouncedGetCompanies()
        }
      },
      searchProjectRef () {
        if (this.searchProjectRef && this.searchProjectRef.length >= 3) {
          this.debouncedGetProjectRef()
        }
      }
      // 'searchBy.status': function (newVal, oldVal) {
      //   console.debug(`new: ${newVal} , old: ${oldVal}`)
      //   this.getVisit()
      // }
    },
    created () {
      this.debouncedGetData = _.debounce(this.getVisit, 500)
      this.debouncedGetCompanies = _.debounce(this.getCompaniesPaging, 500)
      this.debouncedGetProjectRef = _.debounce(this.getProjectsRefPaging, 500)
      // this.getCompanies()
      this.getUserLogins()
      this.getUserLoginsMap()
      let today = new Date()
      this.searchBy.visitDateTo = today.toISOString().split('T')[0]
      let oToday = new Date()
      oToday.setMonth(oToday.getMonth() - 2)
      this.searchBy.visitDateFrom = oToday.toISOString().split('T')[0]
    },
    methods: {
      // async changeShowTextInfo () {
      //   this.projectAddInfo = this.editedItem.project.addInfo
      // },
      hasAttachUrl (item) {
        return !_.isEmpty(item.attachUrl)
      },
      async getUserLoginsMap () {
        try {
          let response = await this.$http.get(`/api/userlogin/all`)
          let userLogins = response.data
          this.userLoginMap = userLogins.reduce(function (map, obj) {
            map[obj.username] = `${obj.username} (${obj.employee.firstName})`
            return map
          }, {})
        } catch (error) {
          console.log(error)
        }
      },
      usernameItemText (item) {
        if (item.employee) { // bug workaround
          return item.username + ' (' + item.employee.firstName + ')'
        } else {
          return item.username
        }
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      async fetchData () {
        const response = await this.$http.get(`/api/visit/all?vt=${this.visitType}`)
        return response.data
      },
      async getUserLogins () {
        try {
          let response = await this.$http.get(`/api/userlogin/select?restrict=true`)
          this.userLogins = response.data
          this.userLogins.unshift({ id: null, username: '' })
        } catch (error) {
          console.log(error)
        }
      },
      showProgressBar () {
        this.loadingBar = true
      },
      hideProgressBar () {
        this.loadingBar = false
      },
      async getVisit () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search || ''
          let id = this.$route.query.nid // query params -> id visit from directURL
          let pageNoXHR = page - 1
          let querySearchParam = `&qst=${this.searchBy.status}&qsh=${this.searchBy.shodanYN}&id=${this.$route.query.nid}&qcby=${this.searchBy.createdBy}&qvdf=${this.searchBy.visitDateFrom}&qvdt=${this.searchBy.visitDateTo}`
          let response = await this.$http.get(`/api/visit?vt=${this.visitType}&ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || 'visitDate'}&dc=${descending || true}&q=${q}` + querySearchParam)

          this.loading = false
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },
      async onSelectProjects (item) {
        // reset customer, company
        if (this.visitType === 'PROJECT' && item) {
          console.log(item.customer)
          this.editedItem.customer.company = item.customer.company
          this.editedItem.customerSelect = item.customer
          this.searchCompany= item.customer.company.name
          //this.getCompaniesPaging() // now need to get customer first
          //this.getCustomers()
          this.customers.push(item.customer) // Clear previous task selection
          this.companies.push(item.customer.company)
        }
      },

      async onSelectCompany () {
        // reset project/shodan
        this.getCustomers()
        if (this.visitType === 'SALES') {
          this.shodans = []
          this.showShodanSelect = false
          this.editedItem.shodan = {}
        } else {
          this.projects = []
          this.showProjectSelect = false
          this.editedItem.project = {}
        }
        // this.getProjects() // now need to get customer first
      },
      async getCustomers () { // TODO: add filter by project.customer.id
        try {
          let response = await this.$http.get(`/api/customer/select?companyId=${this.editedItem.customer.company.id}`)
          this.customers = response.data
          let custobj = _.find(this.customers, ['id', this.editedItem.customer.id])
          this.editedItem.customerSelect = custobj || ''
          this.showCustomerSelect = true
        } catch (error) {
          console.log(error)
        }
      },
      async getCompaniesPaging () { // paging not yet implemented
        try {
          // const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.searchCompany == null ? '' : this.searchCompany
          // let pageNoXHR = page - 1
          // let response = await this.$http.get(`/api/company/select?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)
          let response = await this.$http.get(`api/company/autocomplete?ps=100&pn=0&so=name&q=${q}`)

          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getCompanies () { // TODO: add filter by project.customer.company.id
        try {
          let response = await this.$http.get('/api/company/select')
          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async onSelectCustomerGetShodansOrProjects () {
        if (this.visitType === 'SALES') {
          this.getShodans()
          this.editedItem.shodan = {}
        } else {
          this.getProjects()
          this.editedItem.project = {}
        }
      },
      async getShodans () {
        try {
          let response = await this.$http.get(`/api/shodan/select?status=OPEN&cid=${this.editedItem.customerSelect.id || ''}`)
          this.shodans = response.data
          this.showShodanSelect = true
        } catch (error) {
          console.log(error)
        }
      },
      async getProjectsRefPaging () { // paging not yet implemented
        try {
          let q = this.searchProjectRef == null ? '' : this.searchProjectRef
          let response = await this.$http.get(`api/project/autocomplete?ps=100&pn=0&so=refNo&q=${q}`)

          this.projects = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getProjects () {
        try {
          let response = await this.$http.get(`/api/project/select?companyid=${this.editedItem.customer.company.id}&cid=${this.editedItem.customerSelect.id || ''}`)
          this.projects = response.data
          this.showProjectSelect = true
        } catch (error) {
          console.log(error)
        }
      },
      reset () { // seems not used
        this.$refs.form1.resetValidation()
        this.resetInline()
        this.date = ''
        this.editedItem = Object.assign({}, this.defaultItem)
        this.showCustomerSelect = false
        this.showShodanSelect = false
        this.howProjectSelect = false
      },
      close () {
        this.dialog = false
        this.$refs.form1.resetValidation()
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.showCustomerSelect = false
          this.showShodanSelect = false
          this.showProjectSelect = false
          this.date = ''
          this.editedIndex = -1
        }, 300)
      },
      editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.getCustomers() // populate during edit
        this.editedItem.customerSelect = this.editedItem.customer
        this.searchCompany = this.editedItem.customer.company.name
        this.getCompaniesPaging()
        this.getShodans()
        this.getProjects()
        this.dialog = dbox
      },
      async deleteItem (rec) {
        this.dialogDelete = false
        let endpoint = `api/visit/${rec.id}`
        let method = 'delete'
        let s = {}
        try {
          let response = await this.$store.dispatch('updateTableItem', { endpoint, s, method })
          if (response.data.message == 'FAILED') {
            this.cancelInline(response.data.details)
            return
          }
          this.DataList.splice(this.DataList.indexOf(rec), 1)
          this.deleteInline()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
      },
      async saveVisit () {
        if (!this.$refs.form1.validate()) {
          console.log('validation fail direct')
          return false
        }
        this.editedItem.type = this.visitType
        let tableItem = this.editedItem
        tableItem.customer = this.editedItem.customerSelect
        // this.editedItem.company.name = _.find(this.companies, { 'id': this.editedItem.customer.company.id }).name
        // this.editedItem.customer.name = _.find(this.customers, { 'id': this.editedItem.customer.id }).name

        if (this.editedIndex > -1) {
          let endpoint = `api/visit/${this.editedItem.id}`
          let method = 'patch'
          try {
            let response = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            if (response.data.message == 'FAILED') {
              this.cancelInline(response.data.details)
              return
            }
            Object.assign(this.DataList[this.editedIndex], this.editedItem)
            this.saveInline()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        } else {
          let endpoint = `api/visit`
          let method = 'post'
          try {
            let resp = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            this.saveInline()
            this.getVisit()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        }
        this.close()
      },
      showShodanOrProject (obj) {
        if (obj.type === 'PROJECT') {
          if (!_.isEmpty(obj.project) && !_.isEmpty(obj.project.refNo)) {
            return obj.project.refNo
          }
        } else {
          if (!_.isEmpty(obj.shodan) && !_.isEmpty(obj.shodan.name)) {
            return obj.shodan.name
          }
        }
        return 'N/A'
      },
      async loadFile (e) {
        /** Load same file would not work!! @change event **/
          // const files = e.target.files
        const fileref = this.$refs.inputUpload.files
        console.debug(fileref.length)
        if (fileref[0] == undefined || fileref[0].type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.fileFormatSnack()
          return
        }
        if (fileref[0] !== undefined) {
          console.debug(fileref[0].name)
          console.debug('Type: ' + fileref[0].type)
          console.debug('Size: ' + fileref[0].size + ' bytes')
          const fr = new FileReader()
          fr.readAsDataURL(fileref[0])
          fr.addEventListener('load', async () => {
            // console.debug(fr.result)
            // this.imageFile = files[0] // this is an image file that can be sent to server...
            // let response = await this.$store.dispatch('uploadFile', { file, endpoint })
            // console.debug(response)
            this.file = fileref[0]
            this.showFilename = true
            this.uploadFileDisabled = false
          })
        } else {
          this.file = {}
        }
      },
      async uploadFile () {
        let endpoint = `api/excel/visit?vt=${this.visitType}`
        let filexls = this.file
        console.debug(this.file)
        try {
          this.uploadFileLoading = true
          this.showProgressBar()
          this.uploadFileDisabled = true
          this.selectFileDisabled = true
          let response = await this.$store.dispatch('uploadFile', { filexls, endpoint })
          this.uploadResponse = response.data
          console.log(this.uploadResponse)
          this.dialogUploadFinish = true
          this.getVisit()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
        this.showFilename = false
        this.uploadFileLoading = false
        this.hideProgressBar()
        this.selectFileDisabled = false
        this.file = {}
        this.$refs.inputUpload.value = '' // make sure it is free from file object
      },
      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (text) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = text || 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      resetInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      fileFormatSnack () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Please select xls/xlsx file'
      }
    }

  }
</script>

<style scoped>

</style>
